import { useNavigation } from '@react-navigation/native';
import { RootStackParamList, TypedNavigation } from 'src/routes/_shared/navigation.types';

export function useTypedNavigation<T extends keyof RootStackParamList>() {
  return useNavigation<TypedNavigation<T>>();
}
